// extracted by mini-css-extract-plugin
export var label = "_cs-5";
export var slideContainer = "_cs-0";
export var slider = "_cs-1";
export var sliderLg = "_cs-4";
export var sliderMd = "_cs-3";
export var sliderSm = "_cs-2";